"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var $ = require("jquery");
var l = require("lenovo");
var createClass = require("create-react-class");
// The app stores all the data that the component will use
var app;
// Special object for this component
var TabType;
(function (TabType) {
    TabType[TabType["ViewHistory"] = 0] = "ViewHistory";
    TabType[TabType["MyProducts"] = 1] = "MyProducts";
})(TabType || (TabType = {}));
;
var translate = ["added to my products|Added to My Products",
    "added to my products successfully|Added to my products successfully",
    "add to my products failed|Add to my products failed",
    "add to my products failed|Add to my products failed",
    "add to my products|Add to my products",
    "no history products result|You currently have no viewing history",
    "no save products result|You currently have no saved products",
    "customize your support experience|Customize your support experience",
    "log in|Log in",
    "log in to access your products|Log in to access your products",
    "i need help with my lenovo id|I need help with my Lenovo ID",
    "create One|Create One",
    "do not have an account|Don't have an account?",
    "viewing history|Viewing history",
    "my products|My products",
    "caps select with account|Select a product from my account, please login or create account",
    "show|Show",
    "hide|Hide"
];
translate = l.Translator.translateGroup(translate);
// Describes how to build the app. Update the app to refresh the component
var appLogic = function (data) {
    var isLoggedOn = l.AccountAuthentication.isLogin();
    var currentTabType = TabType.MyProducts;
    var historyProducts = [];
    var myProducts = [];
    var productListenerCompt = {}; //this will be saved as ProductsList component when component Mount
    var isRefreshMyProducts = false;
    var updateLoginStatus = function (status) {
        this.isLoggedOn = status;
        this.productListener.changed();
    };
    var updateMyProductsAndHistroy = function (callback) {
        var that = this;
        l.Content.getContentAsync(null, "MyProductsAndViewHistory", function (dataSet) {
            if (dataSet) {
                historyProducts.length = 0;
                if (dataSet["myViewHistory"]) {
                    $.each(dataSet.myViewHistory, function (index, val) {
                        historyProducts.push({
                            fullProduct: val.ID, image: val.Image, productName: val.Name, serial: val.Type === "Product.Serial" ? val.Serial : "", brand: val.Brand, inMyProducts: val.InMyProducts
                        });
                    });
                }
                myProducts.length = 0;
                if (dataSet["myproducts"]) {
                    $.each(dataSet.myproducts, function (index, val) {
                        myProducts.push({ fullProduct: val.ID, image: val.Image, productName: val.Name, serial: val.Type === "Product.Serial" ? val.Serial : "", brand: val.Brand });
                    });
                }
            }
            if (that && that.productListener["changed"] && typeof that.productListener["changed"] === "function")
                that.productListener.changed();
            callback && callback();
        }, function (d) { return d; }, false);
    };
    var updateTabType = function (type) {
        this.currentTabType = type;
        if (isRefreshMyProducts) {
            isRefreshMyProducts = false;
            this.updateMyProductsAndHistroy(this.productListener.changed());
        }
        else
            this.productListener.changed();
    };
    return {
        isLoggedOn: isLoggedOn,
        get isRefreshMyProducts() {
            return isRefreshMyProducts;
        },
        set isRefreshMyProducts(value) {
            isRefreshMyProducts = typeof value === "boolean" ? value : false;
        },
        currentTabType: currentTabType,
        historyProducts: historyProducts,
        myProducts: myProducts,
        productListener: productListenerCompt,
        updateLoginStatus: updateLoginStatus,
        updateTabType: updateTabType,
        updateMyProductsAndHistroy: updateMyProductsAndHistroy
    };
};
var capsHistorySlickConfig = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: false,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                dots: false
            }
        }
    ]
};
// Describes how to render the component
var render = function (element) {
    var TabList = createClass({
        getInitialState: function () {
            return {
                app: app
            };
        },
        componentDidMount: function () {
        },
        componentDidUpdate: function () {
        },
        onClick: function (e) {
            var app = this.state.app;
            var $this = $(e.currentTarget);
            var tabtype = $this.hasClass("view-history") ? TabType.ViewHistory : TabType.MyProducts;
            if (!$this.hasClass("selected")) {
                $this.addClass("selected");
                $this.siblings().removeClass("selected");
                app.updateTabType(tabtype);
            }
        },
        render: function () {
            return (React.createElement("ul", { className: "tabs list-inline list-unstyled" },
                React.createElement("li", { className: "view-history", onClick: this.onClick, tabindex: "" }, translate["viewing history"]),
                React.createElement("li", { className: "my-products selected", onClick: this.onClick }, translate["my products"])));
        }
    });
    var ProductsList = createClass({
        getInitialState: function () {
            return {
                app: app
            };
        },
        getDefaultProps: function () {
            return {
                renderType: TabType.MyProducts
            };
        },
        componentWillMount: function () {
            this.state.app.productListener = this;
            if ($(this.refs.prodsModule)) {
                $(this.refs.prodsModule).slick(capsHistorySlickConfig);
            }
        },
        componentDidMount: function () {
            if ($(this.refs.prodsModule)) {
                $(this.refs.prodsModule).slick(capsHistorySlickConfig);
            }
        },
        componentWillUpdate: function () {
            if ($(this.refs.prodsModule)) {
                $(this.refs.prodsModule).slick("unslick");
            }
        },
        componentDidUpdate: function () {
            if ($(this.refs.prodsModule)) {
                $(this.refs.prodsModule).slick(capsHistorySlickConfig);
            }
        },
        changed: function () {
            this.forceUpdate();
        },
        login: function () {
            var dealUrl = function (url) {
                var returnUrl = l.UrlUtility.getUrlParam("cb", false, url);
                var urlList = returnUrl.split('?');
                if (urlList.length > 1) {
                    urlList[urlList.length - 1] = "caps=true&" + urlList[urlList.length - 1];
                }
                if (urlList.length === 1) {
                    urlList.push("caps=true");
                }
                var newReturnUrl = urlList.join('?');
                var loginUrl = url.replace(/([?|&])cb=([^&;]+?)(&|#|;|$)/i, function (s0, s1, s2, s3) {
                    return s1 + "cb=" + encodeURIComponent(newReturnUrl) + s3;
                });
                return loginUrl;
            };
            window.location.href = dealUrl(l.AccountAuthentication.getPassportLenovoUrl('NewLenovoLoginUrl'));
        },
        signup: function () {
            window.location.href = l.AccountAuthentication.getPassportLenovoUrl('NewLenovoSignupUrl');
        },
        productRedirect: function (e) {
            var $this = $(e.currentTarget);
            var $thisItem = $this.parents(".prod-item:first");
            var $thisCapsModal = $this.parents("#capsModal:first");
            var tabName = ($thisCapsModal && $thisCapsModal.length) ? l.UrlUtility.getPSPTabs($thisCapsModal.attr('tabname')) : "";
            var tabSubUrl = ($thisCapsModal && $thisCapsModal.length) ? $thisCapsModal.attr('subUrl') : "";
            var params = {};
            if (tabName)
                params["tabName"] = tabName;
            if (tabSubUrl)
                params["subUrl"] = tabSubUrl;
            l.LitePageLoader.capsRun($thisItem, { id: $thisItem.attr('data-product'), serial: $thisItem.attr('data-serial') ? $thisItem.attr('data-serial').toLowerCase() : null, brand: $thisItem.attr('data-brand') ? $thisItem.attr('data-brand').toUpperCase() : null }, params);
        },
        getProducts: function (e) {
            var result = [];
            var appInState = this.state.app;
            var renderType = this.props.renderType;
            if (renderType === TabType.ViewHistory) {
                result = appInState.historyProducts;
            }
            else if (appInState.isLoggedOn === true) {
                result = appInState.myProducts;
            }
            return result;
        },
        addToMyProducts: function (e) {
            var _this = this;
            var $currentBtn = $(e.target);
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            var $parentItemTag = $currentBtn.parents("div[data-product]");
            var currentProductId = $parentItemTag.attr('data-product');
            if (app.isLoggedOn === false) {
                if (currentProductId) {
                    var capsPrefix = l.GlobalVar.litePageIdPrefix;
                    var $currentCaps = $currentBtn.parents("div[id^='" + capsPrefix + "']").filter(":first");
                    var capsName = $currentCaps.attr("id").replace(new RegExp(capsPrefix, "i"), "");
                    l.SessionStorageUtility.setSessionStorage("capsAddToMyProds", JSON.stringify({ ProductId: currentProductId, CapsName: capsName }));
                }
                this.login();
            }
            else {
                $.get(l.UrlUtility.getFullServicesPath("mse/AddProductById"), { productId: currentProductId }, function (result) {
                    $currentBtn.removeClass("icon-circle-add").text(translate["added to my products"]);
                    var successTip = result.Result ? translate["added to my products successfully"] : translate["add to my products failed"];
                    $currentBtn.siblings(".addTo-tip").html(successTip).fadeIn(500).fadeOut(2000);
                    if (result.Result && !$.isEmptyObject(result.Data)) {
                        var myProductsAndHistoryconfig = $.extend(true, {}, l.Content.item["MyProductsAndViewHistory"]);
                        /**
                         * When dont config ds_{} for API,there is one optimization
                         * it's possible that add "window[config.source] = Data (from API retrun)" in l.Content.getContentAsync to optimize code
                         * if do that ,I can change ds_{} here in order to change it after AddProductById API.
                         * Then other caps in same page won't call API for myproducts or viewhistroy
                         */
                        var val_1 = result.Data;
                        //change the "inMyProducts" of this product in app.histroyProducts
                        app.historyProducts.forEach(function (product, index) {
                            if (product.fullProduct.toLowerCase() === val_1.ID.toLowerCase()) {
                                product.inMyProducts = true;
                            }
                        });
                        if (window.hasOwnProperty(myProductsAndHistoryconfig.source)) {
                            console.log("push product which just added into ds_{},only when ds_{} exists", myProductsAndHistoryconfig.source);
                            var configSource = window[myProductsAndHistoryconfig.source];
                            if (!(configSource && configSource["myViewHistory"])) {
                                //ds_{} is null when myproducts is empty
                                window[myProductsAndHistoryconfig.source]["myViewHistory"] = [];
                            }
                            var dsViewHistory = configSource["myViewHistory"];
                            dsViewHistory.forEach(function (product, index) {
                                if (product.ID.toLowerCase() === val_1.ID.toLowerCase()) {
                                    product.InMyProducts = true;
                                }
                            });
                            if (!(configSource && configSource["myproducts"])) {
                                //ds_{} is null when myproducts is empty
                                window[myProductsAndHistoryconfig.source]["myproducts"] = [];
                            }
                            (configSource["myproducts"]).unshift(val_1);
                            app.myProducts.unshift({ fullProduct: val_1.ID, image: val_1.Image, productName: val_1.Name, serial: val_1.Type === "Product.Serial" ? val_1.Serial : "", brand: val_1.Brand });
                        }
                        else {
                            //if there is no ds_{} cache,query api
                            app.isRefreshMyProducts = true;
                        }
                        debugger;
                        _this.props.refreshCount(app.myProducts.length);
                        /***************
                        if (window.hasOwnProperty(myProductsConfig.source)) {
                            console.log("push product which just added into ds_{}", myProductsConfig.source);
                            let val = result.Data;
                            //change the "inMyProducts" of this product in app.histroyProducts
                            app.historyProducts.forEach((product, index) => {
                                if (product.fullProduct.toLowerCase() === val.ID.toLowerCase()) {
                                    product.inMyProducts = true;
                                }
                            });
                            if (!window[myProductsConfig.source]) {
                                //ds_{} is null when myproducts is empty
                                (window as any)[myProductsConfig.source] = [];
                            }
// ReSharper disable once TsResolvedFromInaccessibleModule
                            (window[myProductsConfig.source]).unshift(val);
                        }
                        app.isRefreshMyProducts = true;

                        if (window.hasOwnProperty(myViewHistoryconfig.source)) {
                            //this will add to this product to MyViewHistory's ds_{}, if other caps load,it will read ds_{} directly
                            console.log("push product which just added into ds_{}", myViewHistoryconfig.source);
                            let val = result.Data;
                            val["InMyProducts"] = true;
                            if (!window[myViewHistoryconfig.source]) {
                                (window as any)[myViewHistoryconfig.source] = [];
                            }
// ReSharper disable once TsResolvedFromInaccessibleModule
                            window[myViewHistoryconfig.source].unshift(val);
                        }
                        ********************/
                    }
                });
            }
        },
        fixImageUrl: function (url) {
            if (!url)
                return "/esv4/images/imageerror.jpg";
            return url;
        },
        render: function () {
            var _this = this;
            console.log("myproducts tab rendering");
            var app = this.state.app;
            var renderType = this.props.renderType;
            if (renderType === TabType.ViewHistory || app.isLoggedOn === true) {
                var products = this.getProducts();
                var productList = [];
                if (products && products.length) {
                    var index_1 = 1;
                    products.forEach(function (product) {
                        var isCurrentDOM = product.isCurrent ? React.createElement("label", { className: "current" },
                            React.createElement("span", { className: "icon-yes" }),
                            React.createElement("span", null, "Selected product")) : React.createElement("label", { className: 'empty' });
                        var isInMyProudctsTip = product.inMyProducts ? "added to my products" : "add to my products";
                        var addToMyProductsBtn = renderType === TabType.ViewHistory ?
                            (product.inMyProducts ?
                                React.createElement("span", { className: "addBtn" }, translate[isInMyProudctsTip])
                                : React.createElement("span", { className: "addBtn icon-circle-add", onClick: _this.addToMyProducts.bind(_this) }, translate[isInMyProudctsTip]))
                            : null;
                        var addToMyProductsTip = renderType === TabType.ViewHistory ? React.createElement("p", { className: "addTo-tip" }) : null;
                        var snContent = product.serial ? React.createElement("span", null,
                            "SN: ",
                            product.serial) : null;
                        productList.push(React.createElement("div", { className: "prod-item", "data-product": product.fullProduct, "data-serial": product.serial, "data-brand": product.brand },
                            React.createElement("div", { className: "prod-img-area" },
                                React.createElement("img", { src: _this.fixImageUrl(product.image), alt: "", onClick: _this.productRedirect })),
                            React.createElement("div", { className: "product-content" },
                                React.createElement("label", { onClick: _this.productRedirect }, product.productName),
                                isCurrentDOM,
                                snContent,
                                addToMyProductsBtn,
                                addToMyProductsTip)));
                        index_1++;
                    });
                    return (React.createElement("div", { className: "caps-history" },
                        React.createElement("div", { className: "prods-module", ref: "prodsModule" }, productList)));
                }
                else {
                    var noResultFindTranslateKey = renderType === TabType.ViewHistory ? "no history products result" : "no save products result";
                    return (React.createElement("div", { className: "caps-history text-center" },
                        React.createElement("span", { className: "caps-no-result" }, translate[noResultFindTranslateKey])));
                }
            }
            else {
                return (React.createElement("div", { className: "caps-login" },
                    React.createElement("h4", null, translate["caps select with account"]),
                    React.createElement("button", { className: "btn btn-default", style: { "text-transform": "capitalize" }, onClick: this.login }, translate["log in"]),
                    React.createElement("button", { className: "btn btn-default", style: { "text-transform": "capitalize" }, onClick: this.signup }, translate["create One"])));
            }
        }
    });
    var ALLProducts = createClass({
        getInitialState: function () {
            return {
                app: app,
                myProductShow: false,
                myProductCount: app.myProducts,
                viewHistoryShow: false,
                viewHistoryCount: app.historyProducts,
            };
        },
        toggleShow: function (renderType, e) {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            var _a = this.state, app = _a.app, viewHistoryShow = _a.viewHistoryShow, myProductShow = _a.myProductShow;
            if (renderType == TabType.ViewHistory) {
                this.setState({ viewHistoryShow: !viewHistoryShow });
            }
            if (renderType == TabType.MyProducts) {
                this.setState({ myProductShow: !myProductShow });
            }
            app.updateTabType(renderType);
        },
        refreshCount: function (renderType, e) {
            var _this = this;
            if (renderType == TabType.ViewHistory) {
                return function (count) { return _this.setState({ viewHistoryCount: count }); };
            }
            if (renderType == TabType.MyProducts) {
                return function (count) { return _this.setState({ myProductCount: count }); };
            }
        },
        render: function () {
            var _a = this.state, app = _a.app, viewHistoryShow = _a.viewHistoryShow, myProductShow = _a.myProductShow;
            var productStyle = classNames({
                "btn-toggle-mp": true,
                "show-btn": myProductShow,
                "hide-btn": !myProductShow
            });
            var historyStyle = classNames({
                "btn-toggle-vp": true,
                "show-btn": viewHistoryShow,
                "hide-btn": !viewHistoryShow
            });
            var productMobileStyle = classNames({
                "btn-toggle-mp": true,
                "btn-mobile": true,
                "show-btn": myProductShow,
                "hide-btn": !myProductShow,
                "icon-s-down": !myProductShow,
                "icon-s-up": myProductShow
            });
            var historyMobileStyle = classNames({
                "btn-toggle-vp": true,
                "btn-mobile": true,
                "show-btn": viewHistoryShow,
                "hide-btn": !viewHistoryShow,
                "icon-s-down": !viewHistoryShow,
                "icon-s-up": viewHistoryShow
            });
            // let myProductCountStr = myProductCount === -1 ? "" : ` (${myProductCount})`;
            // let viewHistoryCountStr = viewHistoryCount === -1 ? "" : ` (${viewHistoryCount})`;
            var myProductCountStr = " (" + (app.myProducts.length || 0) + ")";
            var viewHistoryCountStr = " (" + (app.historyProducts.length || 0) + ")";
            return (React.createElement("ul", { className: "list-unstyled" },
                React.createElement("li", { className: "tabs-title" },
                    React.createElement("span", null,
                        translate["viewing history"],
                        viewHistoryCountStr),
                    React.createElement("span", { className: historyStyle, onClick: this.toggleShow.bind(this, TabType.ViewHistory) },
                        " ",
                        translate[viewHistoryShow ? "hide" : "show"]),
                    React.createElement("span", { className: historyMobileStyle, onClick: this.toggleShow.bind(this, TabType.ViewHistory) })),
                React.createElement("li", { style: { display: viewHistoryShow ? "block" : "none" } },
                    React.createElement(ProductsList, { renderType: TabType.ViewHistory, refreshCount: this.refreshCount.bind(this, TabType.ViewHistory) })),
                React.createElement("li", { className: "tabs-title" },
                    React.createElement("span", null,
                        translate["my products"],
                        myProductCountStr),
                    React.createElement("span", { className: productStyle, onClick: this.toggleShow.bind(this, TabType.MyProducts) }, translate[myProductShow ? "hide" : "show"]),
                    React.createElement("span", { className: productMobileStyle, onClick: this.toggleShow.bind(this, TabType.MyProducts) })),
                React.createElement("li", { style: { display: myProductShow ? "block" : "none" } },
                    React.createElement(ProductsList, { renderType: TabType.MyProducts, refreshCount: this.refreshCount.bind(this, TabType.MyProducts) }))));
        }
    });
    var render = function () {
        ReactDOM.render(React.createElement(ALLProducts, null), element);
    };
    return {
        render: render
    };
};
// The public method to be called
exports.load = function (element) {
    l.DebugInfo.log("My Products rendering");
    app = appLogic(null);
    app.updateMyProductsAndHistroy(function () {
        var r = render(element);
        r.render();
    });
};
